module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "matics"
  }, [_c('viewer', {
    attrs: {
      "images": _vm.urls
    }
  }, [_vm._l((_vm.urls), function(a, i) {
    return [(i <= 13) ? _c('img', {
      attrs: {
        "src": a
      }
    }) : _vm._e()]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20b363f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/advHtml/matics.vue
// module id = 521
// module chunks = 2